// @flow
import React, { type Element } from 'react';
import { Field } from 'redux-form-normalize-on-blur';
import { InputField } from 'angieslist-app-platform/lib/browser/forms';
import { Col, Row } from 'angieslist-react-components';
import moment from 'moment';
import './EditHours.scss';

type Props = {
    day: string,
    openHours: string,
    closeHours: string,
    open247: boolean,
    isClosed: boolean,
    change: Function,
};

type State = {
  prevOpenValue: string,
  prevCloseValue: string,
}

const timeFormats = ['hh:mm a', 'h:mm a', 'HH:mm', 'H:mm'];

const formatHours = (value) => {
  const momentValue = moment(value, timeFormats).format('hh:mm a');
  if (value === '') {
    return '';
  }
  return momentValue === 'Invalid date' ? '##:## AM' : momentValue;
};


class HourFieldComponent extends React.Component<Props, State> {
    state: State = {
      prevOpenValue: '',
      prevCloseValue: '',
    }

    props: Props

    toggleCloseDay: ((event: any, isClosed: boolean) => void) =
    (event: Object, isClosed: boolean) => {
      const {
        change, day, openHours, closeHours,
      } = this.props;
      const { prevOpenValue, prevCloseValue } = this.state;
      if (isClosed) {
        this.setState({
          prevOpenValue: openHours,
          prevCloseValue: closeHours,
        });
        change(`open${day}`, '');
        change(`close${day}`, '');
      } else {
        change(`open${day}`, prevOpenValue);
        change(`close${day}`, prevCloseValue);
        this.setState({
          prevOpenValue: '',
          prevCloseValue: '',
        });
      }
    }

    render(): Element<"div"> {
      const { day, open247, isClosed } = this.props;
      const disableInput = isClosed || open247;
      return (
        <div>
          <Row className="Closed-By-Day-Wrapper margin-b10">
            <Col xs={3} md={2}>
              <strong>{day}</strong>
            </Col>
          </Row>
          <Row className="margin-b20">
            <Col xs={5} md={3}>
              <Field
                name={`open${day}`}
                id={`Edit-Hours--Open-${day}`}
                component={InputField}
                type="text"
                placeholder="##:## AM"
                disabled={disableInput}
                normalizeOnBlur={value => formatHours(value)}
              />
            </Col>

            <Col xs={5} md={1} className="hours-divider--column">
              <hr className="hours-divider--line" />
            </Col>

            <Col xs={5} md={3}>
              <Field
                name={`close${day}`}
                id={`Edit-Hours--Closed-${day}`}
                component={InputField}
                type="text"
                placeholder="##:## PM"
                disabled={disableInput}
                normalizeOnBlur={value => formatHours(value)}
              />
            </Col>

            <Col xs={5} md={2} className="margin-l20">
              <Field
                name={`isClosed${day}`}
                label="Closed"
                id={`Edit-Hours--isClosed-${day}`}
                component={InputField}
                type="checkbox"
                disabled={open247}
                onChange={this.toggleCloseDay}
              />
            </Col>
          </Row>
        </div>);
    }
}

export default (HourFieldComponent);



// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/HoursField.js